import React, { useState } from 'react';
import { Download, Menu, X, Moon, Sun } from 'lucide-react';
import { scrollToSection, downloadCV } from '../../utils';
import './Navbar.css';

const Navbar = ({ activeSection, setActiveSection, theme, toggleTheme }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navItems = ['Home', 'About', 'Services', 'Projects', 'Skills', 'Contact'];

  const handleNavClick = (item) => {
    scrollToSection(item.toLowerCase(), setActiveSection, setIsMenuOpen);
  };

  return (
    <nav className="navbar navbar-glass">
      <div className="navbar-container">
        <div className="navbar-content">
          <button
            onClick={() => handleNavClick('home')}
            className="navbar-logo gradient-text"
          >
            EW
          </button>

          <div className="navbar-links">
            {navItems.map((item) => (
              <button
                key={item}
                onClick={() => handleNavClick(item)}
                className={`nav-link ${activeSection === item.toLowerCase() ? 'active' : ''}`}
              >
                {item}
              </button>
            ))}

            <button
              onClick={toggleTheme}
              className="theme-toggle"
              aria-label="Toggle theme"
              title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
            >
              {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
            </button>

            <button onClick={downloadCV} className="navbar-cv-btn">
              <Download size={16} />
              CV
            </button>
          </div>

          <div className="navbar-mobile-actions">
            <button
              onClick={toggleTheme}
              className="theme-toggle"
              aria-label="Toggle theme"
            >
              {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
            </button>
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="navbar-mobile-toggle"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div className="navbar-mobile-menu navbar-glass">
          <div className="navbar-mobile-content">
            {navItems.map((item) => (
              <button
                key={item}
                onClick={() => handleNavClick(item)}
                className={`navbar-mobile-link ${activeSection === item.toLowerCase() ? 'active' : ''}`}
              >
                {item}
              </button>
            ))}
            <button onClick={downloadCV} className="navbar-mobile-cv-btn">
              <Download size={16} />
              Download CV
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
